import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {Button, Grid, Header, Input, Modal, ProgressBar, styles, Surface, Text, useTheme} from "tmwx-design-web/src";
import {useTranslation} from "react-i18next";
import {isEmpty} from "gui-common/appHelper";
import {usePermissions} from "tmwx-design-common";
import {ControlParam} from "gui-common/redux/data/metricParam";
import {getControlParamList} from "gui-common/redux/action/efe/metricParamActions";
import {metricParamActions} from "gui-common/redux/slice/efe/metricParamSlice";

function ModalRow({controlParam, handleOnClick}: { controlParam: ControlParam, handleOnClick: (controlParam: ControlParam) => void }) {
    const {roundness, padding, colors} = useTheme()
    const {t} = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={'row'} style={{
            ...styles.row, ...styles.justifyContent_spaceBetween,
            ...{padding: padding},
            alignItems: 'center'
        }} onClick={() => handleOnClick(controlParam)}>
            {/*<Icon name={'remove'}/>*/}

            <Text bold>
                {controlParam.cpsName}
            </Text>

            <Text>
                {controlParam.cpsTag}
            </Text>

            <Text>
                {controlParam.cpsVersion}
            </Text>

            <Button
                size="small"
                variant="contained"
                onPress={() => handleOnClick(controlParam)}
            >
                {t('select')}
            </Button>

            <style>
                {`
                .row {
                background-color: ${colors.elevation.level0};
            }

                .row:hover {
                background-color: ${colors.elevation.level1};
                cursor:pointer;
            }
                `}
            </style>
        </div>

    );
}

const ControlParamSearchModal = ({label}: { label: string }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const { hasRights } = usePermissions()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('')

    const loading = useSelector<RootState, boolean>(state => state.metricParam.loading);
    const controlParamList = useSelector<RootState, ControlParam[]>(state => state.metricParam.controlParamList);

    useEffect(() => {
        if (hasRights(["efe_metric_param_view"])) {
            dispatch(getControlParamList());
        }
    }, [dispatch]);

    const handleOnClick = (selectedControlParam: ControlParam) => {
        dispatch(metricParamActions.setSelectedControlParam(selectedControlParam))
        handleClose()
    }

    const handleClose = () => {
        setIsDialogOpen(false);
    };

    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };

    return (
        <Surface style={{marginBottom: 4, marginLeft: 4, marginRight: 4, width: '100%'}}>
            <div onClick={handleDialogOpen}>
                <Input
                    style={{ml: 1, fontWeight: 500}}
                    fullWidth
                    placeholder={t('efe.controlParamSearch')}
                    value={label}
                />
            </div>

            <Modal
                visible={isDialogOpen}
                type='dialog'
                dialogMaxWidth='m'
                contentElevation={0}
                closeModal={handleClose}
                header={(
                    <Header
                        title={t('efe.controlParamSearch')}
                        actionRight={<Button iconLeft={'clear'} status='neutral' variant='ghost'
                                             onPress={handleClose}/>}
                    />
                )}
            >
                <Surface elevation={0}>
                    <Grid.Container centered maxWidth="xl">
                        <Grid.Col m={12} lg={12} xl={12}>
                            <Input
                                style={{ml: 1, fontWeight: 500}}
                                fullWidth
                                icon={"search"}
                                placeholder={t('efe.controlParamSearch')}
                                value={search}
                                onChangeValue={(text) => setSearch(text)}
                            />
                        </Grid.Col>

                        <Grid.Col m={12} lg={12} xl={12}>

                            {(loading || isEmpty(controlParamList)) ? (
                                <ProgressBar animated rounded={false} width={'100%'} height={6} vertical={false}/>
                            ) : (
                                controlParamList.filter((val) => {
                                    if (isEmpty(search)) {
                                        return val;
                                    } else if (val.cpsTag.toLocaleLowerCase().includes(search.toLocaleLowerCase())) {
                                        return val;
                                    }
                                }).map((item, index) => {
                                    return (
                                        <ModalRow key={index} controlParam={item} handleOnClick={() => handleOnClick(item)}/>
                                    );
                                })
                            )}
                        </Grid.Col>
                    </Grid.Container>
                </Surface>
            </Modal>
        </Surface>
    )
}

export default ControlParamSearchModal;